// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__1WdDy","subTitleBold":"BoxSubTitle_subTitleBold__1Y-G6"};